export const USER_TOKEN = 'OMMS_OPERATION_USER_TOKEN'; // 用户token
export const PROXY_TOKEN_STORAGE = 'OMMS_OPERATION_PROXY_TOKEN_STORAGE' // 代登录账号token
export const PROXY_ID = 'OMMS_PROXY_ID' // 代登录账号 - 原账号id

// 上传文件接口，用于请求时转换请求头
export const UPLOAD_URL = ["/contract/uploadFile", "/customer/uploadFile", "/project/receivable/uploadFile"];

// 正则校验

// 手机号正则
export const phone_Reg = /^1[3456789]\d{9}$/;

//校验手机号和固定电话
export const phone_tel_Reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;

// 密码正则
export const pwd_Reg = /^[A-Za-z0-9._!@#]{6,16}$/

// 邮箱正则
export const mail_Reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

// 高德地图安全密钥
export const amap_securityJsCode = '70929a04301ba45c3760ed37444ab971'

// 高德地图安全密钥Key
export const amap_key = '48786f901d8de14eb71c1687f33e40e9'
